<template>

    <div class="page-container flex-column scroll">
      <div class="page_container_content_nav flex-row bottom-shadow col-0">
        <el-autocomplete
          v-model="category"
          :fetch-suggestions="querySearch"
          size="mini"
          placeholder="职能模块"
          class="mr20"
        />
        <el-select
          v-model="selectedIndustry"
          filterable
          clearable
          size="mini"
          placeholder="行业"
          class="mr20"
        >
          <el-option v-for="(v, index) in industry" :key="index" :value="v" :label="v"/>
        </el-select>
        <el-select v-model="rankType" size="mini" placeholder="行业" class="mr20">
          <el-option value="专业职级" label="专业职级"/>
          <el-option value="管理职级" label="管理职级"/>
        </el-select>
        <div class="mr20">
          <el-button type="primary" size="mini" @click="loadData">查看</el-button>
        </div>
        <el-button
          :disabled="checkList.length === 0"
          type="primary"
          size="mini"
          @click="exportExel"
        >导出Exel</el-button>
      </div>
      <div v-if="init" v-loading="loading" class="col-1 scroll">
        <div v-for="(company, i) in companies" :key="company._id" class="flex-row">
          <div
            :style="{width: tableWidth[0]}"
            class="col-0 flex-column justify-center salary_table_cell pointer"
            @click="onCheck(i)"
          >
            {{ i + 1 }}
            <el-checkbox v-model="checkList[i]"/>
          </div>
          <div
            :style="{width: tableWidth[1]}"
            class="col-0 item-center flex-row justify-center salary_table_cell"
          >{{ company['简称'] }}</div>
          <div class="col-1 flex-column">
            <div class="flex-row">
              <div :style="{width: tableWidth[2]}" class="salary_table_cell">操作</div>
              <div
                v-for="(col, index) in company.merge"
                :key="index"
                class="salary_table_cell pointer"
                @click="removeCol(company, index)"
              >
                <i class="el-icon-remove table_action_btn"/>
                <div v-if="pedding" class="el-loading-mask"/>
              </div>
              <el-dropdown v-if="!company.pedding" placement="bottom">
                <div class="salary_table_cell pointer">
                  <i class="el-icon-more table_action_btn"/>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="addCol(company)">
                    <i class="el-icon-plus table_action_btn"/> 增加列
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="updateCompanySalary(company)">
                    <i class="el-icon-refresh table_action_btn"/> 同步更新公司薪酬
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="handleSort(company)">
                    <i class="el-icon-sort table_action_btn"/> 排序
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div v-else class="salary_table_cell pointer">
                <i class="el-icon-loading table_action_btn"/>
              </div>
            </div>
            <div class="flex-row">
              <div :style="{width: tableWidth[2]}" class="salary_table_cell">年限</div>
              <div
                v-for="(col, index) in company.merge"
                :key="index"
                class="salary_table_cell pointer"
              >
                <input
                  v-model="col['年限']"
                  :class="col.yearsComputed? 'ft-gray': ''"
                  class="salary_table_cell_input"
                >
                <div v-if="pedding" class="el-loading-mask"/>
              </div>
            </div>
            <div class="flex-row">
              <div :style="{width: tableWidth[2]}" class="salary_table_cell">{{ rankType }}</div>
              <div
                v-for="(col, index) in company.merge"
                :key="index"
                class="salary_table_cell pointer"
              >
                <input
                  v-model="col[rankType]"
                  :class="col.rankComputed? 'ft-gray': ''"
                  class="salary_table_cell_input"
                >
                <div v-if="pedding" class="el-loading-mask"/>
              </div>
            </div>
            <div class="flex-row">
              <div :style="{width: tableWidth[2]}" class="salary_table_cell">指标（万）</div>
              <div
                v-for="(col, index) in company.merge"
                :key="index"
                class="salary_table_cell pointer"
              >
                <!-- <el-popover v-if="format[company['简称']] && format[company['简称']].rank[col[rankType]]"
                            placement="right"
                            width="100"
                            trigger="hover">
                  <div>
                    <p>平均：{{ format[company['简称']].rank[col[rankType]]['指标'][0] / (format[company['简称']].rank[col[rankType]]['指标'][1] || 1) }}</p>
                    <p>范围: {{ format[company['简称']].rank[col[rankType]]['指标'][2] }} ~ {{ format[company['简称']].rank[col[rankType]]['指标'][3] }}</p>
                  </div>
                  <input slot="reference"
                         :class="col.fixedComputed? 'ft-gray': ''"
                         v-model="col['']"
                         class="salary_table_cell_input">
                </el-popover>-->
                <input v-model="col['指标']" class="salary_table_cell_input">
                <div v-if="pedding" class="el-loading-mask"/>
              </div>
            </div>
            <div class="flex-row">
              <div :style="{width: tableWidth[2]}" class="salary_table_cell">固薪（万）</div>
              <div
                v-for="(col, index) in company.merge"
                :key="index"
                class="salary_table_cell pointer"
              >
                <el-popover
                  v-if="format[company['简称']] && format[company['简称']].rank[col[rankType]]"
                  placement="right"
                  width="100"
                  trigger="hover"
                >
                  <div>
                    <p>平均：{{ format[company['简称']].rank[col[rankType]]['固薪'][0] / (format[company['简称']].rank[col[rankType]]['固薪'][1] || 1) }}</p>
                    <p>范围: {{ format[company['简称']].rank[col[rankType]]['固薪'][2] }} ~ {{ format[company['简称']].rank[col[rankType]]['固薪'][3] }}</p>
                  </div>
                  <input
                    slot="reference"
                    v-model="col['固薪']"
                    :class="col.fixedComputed? 'ft-gray': ''"
                    class="salary_table_cell_input"
                  >
                </el-popover>
                <input v-else v-model="col['固薪']" class="salary_table_cell_input">
                <div v-if="pedding" class="el-loading-mask"/>
              </div>
            </div>
            <div class="flex-row">
              <div :style="{width: tableWidth[2]}" class="salary_table_cell">奖金（万）</div>
              <div
                v-for="(col, index) in company.merge"
                :key="index"
                class="salary_table_cell pointer"
              >
                <el-popover
                  v-if="format[company['简称']] && format[company['简称']].rank[col[rankType]]"
                  placement="right"
                  width="100"
                  trigger="hover"
                >
                  <div>
                    <p>平均：{{ format[company['简称']].rank[col[rankType]]['奖金'][0] / (format[company['简称']].rank[col[rankType]]['奖金'][1] || 1) }}</p>
                    <p>范围: {{ format[company['简称']].rank[col[rankType]]['奖金'][2] }} ~ {{ format[company['简称']].rank[col[rankType]]['奖金'][3] }}</p>
                  </div>
                  <input
                    slot="reference"
                    v-model="col['奖金']"
                    :class="col.bonusComputed? 'ft-gray': ''"
                    class="salary_table_cell_input"
                  >
                </el-popover>
                <input v-else v-model="col['奖金']" class="salary_table_cell_input">
                <div v-if="pedding" class="el-loading-mask"/>
              </div>
            </div>
            <div class="flex-row">
              <div :style="{width: tableWidth[2]}" class="salary_table_cell">年薪（万）</div>
              <div
                v-for="(col, index) in company.merge"
                :key="index"
                class="salary_table_cell pointer"
              >
                <el-popover
                  v-if="format[company['简称']] && format[company['简称']].rank[col[rankType]]"
                  placement="right"
                  width="100"
                  trigger="hover"
                >
                  <div>
                    <p>平均：{{ format[company['简称']].rank[col[rankType]]['年薪'][0] / (format[company['简称']].rank[col[rankType]]['年薪'][1] || 1) }} 万</p>
                    <p>范围: {{ format[company['简称']].rank[col[rankType]]['年薪'][2] }} ~ {{ format[company['简称']].rank[col[rankType]]['年薪'][3] }} 万</p>
                  </div>
                  <input
                    slot="reference"
                    v-model="col['年薪']"
                    :class="col.annualComputed? 'ft-gray': ''"
                    class="salary_table_cell_input"
                  >
                </el-popover>
                <input v-else v-model="col['年薪']" class="salary_table_cell_input">
                <div v-if="pedding" class="el-loading-mask"/>
              </div>
            </div>
            <div class="flex-row">
              <div :style="{width: tableWidth[2]}" class="salary_table_cell">奖金机制</div>
              <div
                :style="{width: `${40 * (company.merge.length || 1)}px`}"
                class="salary_table_cell salary_table_cell_min table_cell_border_t pointer"
              >
                <el-popover
                  v-if="format[company['简称']] && format[company['简称']]['奖金机制']"
                  placement="right"
                  width="100"
                  trigger="hover"
                >
                  <div>
                    <div v-for="(item, index) in format[company['简称']]['奖金机制']" :key="index">
                      <a @click="addText({ field: '奖金机制', text: item.content, company })">
                        <i class="el-icon-back"/>
                      </a>
                      {{ item.department }}：{{ item.content }}
                    </div>
                  </div>
                  <textarea
                    slot="reference"
                    v-model="company['奖金机制']"
                    class="salary_table_cell_textarea"
                    @input="onTextareaResize"
                  />
                </el-popover>
                <textarea v-else v-model="company['奖金机制']" class="salary_table_cell_textarea"/>
                <div v-if="pedding" class="el-loading-mask"/>
              </div>
            </div>
            <div class="flex-row">
              <div :style="{width: tableWidth[2]}" class="salary_table_cell">奖金发放时间</div>
              <div
                :style="{width: `${40 * (company.merge.length || 1)}px`}"
                class="salary_table_cell salary_table_cell_min pointer"
              >
                <el-popover
                  v-if="format[company['简称']] && format[company['简称']]['奖金发放时间']"
                  placement="right"
                  width="100"
                  trigger="hover"
                >
                  <div>
                    <p v-for="(item, index) in format[company['简称']]['奖金发放时间']" :key="index">
                      <a @click="addText({ field: '奖金发放时间', text: item.content, company })">
                        <i class="el-icon-back"/>
                      </a>
                      {{ item.department }}：{{ item.content }}
                    </p>
                  </div>
                  <textarea
                    slot="reference"
                    v-model="company['奖金发放时间']"
                    class="salary_table_cell_textarea"
                  />
                </el-popover>
                <textarea v-else v-model="company['奖金发放时间']" class="salary_table_cell_textarea"/>
                <div v-if="pedding" class="el-loading-mask"/>
              </div>
            </div>
            <div class="flex-row">
              <div :style="{width: tableWidth[2]}" class="salary_table_cell">递延机制</div>
              <div
                :style="{width: `${40 * (company.merge.length || 1)}px`}"
                class="salary_table_cell salary_table_cell_min pointer"
              >
                <el-popover
                  v-if="format[company['简称']] && format[company['简称']]['递延机制']"
                  placement="right"
                  width="100"
                  trigger="hover"
                >
                  <div>
                    <p v-for="(item, index) in format[company['简称']]['递延机制']" :key="index">
                      <a @click="addText({ field: '递延机制', text: item.content, company })">
                        <i class="el-icon-back"/>
                      </a>
                      {{ item.department }}：{{ item.content }}
                    </p>
                  </div>
                  <textarea
                    slot="reference"
                    v-model="company['递延机制']"
                    class="salary_table_cell_textarea"
                  />
                </el-popover>
                <textarea v-else v-model="company['递延机制']" class="salary_table_cell_textarea"/>
                <div v-if="pedding" class="el-loading-mask"/>
              </div>
            </div>
            <div class="flex-row">
              <div :style="{width: tableWidth[2]}" class="salary_table_cell">考核指标</div>
              <div
                :style="{width: `${40 * (company.merge.length || 1)}px`}"
                class="salary_table_cell salary_table_cell_min pointer"
              >
                <el-popover
                  v-if="format[company['简称']] && format[company['简称']]['考核指标']"
                  placement="right"
                  width="100"
                  trigger="hover"
                >
                  <div>
                    <p v-for="(item, index) in format[company['简称']]['考核指标']" :key="index">
                      <a @click="addText({ field: '考核指标', text: item.content, company })">
                        <i class="el-icon-back"/>
                      </a>
                      {{ item.department }}：{{ item.content }}
                    </p>
                  </div>
                  <textarea
                    slot="reference"
                    v-model="company['考核指标']"
                    class="salary_table_cell_textarea"
                  />
                </el-popover>
                <textarea v-else v-model="company['考核指标']" class="salary_table_cell_textarea"/>
                <div v-if="pedding" class="el-loading-mask"/>
              </div>
            </div>
            <div class="flex-row">
              <div :style="{width: tableWidth[2]}" class="salary_table_cell">备注</div>
              <div
                :style="{width: `${40 * (company.merge.length || 1)}px`}"
                class="salary_table_cell salary_table_cell_min pointer"
              >
                <el-popover
                  v-if="format[company['简称']] && format[company['简称']]['备注']"
                  placement="right"
                  width="100"
                  trigger="hover"
                >
                  <div>
                    <p v-for="(item, index) in format[company['简称']]['备注']" :key="index">
                      <a @click="addText({ field: '备注', text: item.content, company })">
                        <i class="el-icon-back"/>
                      </a>
                      {{ item.department }}：{{ item.content }}
                    </p>
                  </div>
                  <textarea
                    slot="reference"
                    v-model="company['备注']"
                    class="salary_table_cell_textarea"
                  />
                </el-popover>
                <textarea v-else v-model="company['备注']" class="salary_table_cell_textarea"/>
                <div v-if="pedding" class="el-loading-mask"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="flex-row item-center justify-center col-1">
        <p class="page_container_content_tip">请先选择查询条件，并点击查看</p>
      </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="`根据${rankType}排序`"
      :modal="false"
      :close-on-click-modal="false"
      width="30%"
      center
    >
      <SlickList v-if="sortTarget.merge" v-model="sortTarget.merge" lock-axis="y" class="sortlist">
        <SlickItem
          v-for="(item, index) in sortTarget.merge"
          :key="index"
          :index="index"
          class="sortlist-item"
        >{{ item[rankType] }}</SlickItem>
      </SlickList>
    </el-dialog>
    </div>


</template>

<script>
import { SlickList, SlickItem } from 'vue-slicksort'
import {download} from '../constant/utils'

const staticSheet = [
  '工作年限',
  '专业职级',
  '指标',
  '固薪',
  '奖金',
  '年薪',
  '奖金机制',
  '奖金发放时间',
  '递延机制',
  '考核指标',
  '备注',
]

// TODO refactor
export default {
  components: {
    SlickItem,
    SlickList,
  },
  data() {
    return {
      init: false,
      category: '',
      industry: app.industries || [],
      selectedIndustry: '',
      rankType: '专业职级',
      companies: [],
      tableWidth: ['', '80px', '80px'],
      format: {},
      dialogVisible: false,
      sortTarget: {},
      checkList: [],
      loading: false,
    }
  },
  computed: {
    download() {
      return download
    },
  },
  watch: {
    rankType(val) {
      this.loadData()
    },
  },
  mounted() {
    this.getCategories()
  },
  methods: {
    async getCategories() {
      if (this.categories) return
               const res = await window.app.service('project').simpleCategories()
        this.categories = res.map((val) => ({
          label: val.名称,
          value: val.名称,
        }))

    },
    querySearch(queryString, cb) {
      const options = this.categories || []
      const results = queryString
        ? options.filter(
            val =>
              val.label &&
              val.label.toLowerCase().includes(queryString.toLowerCase()),
          )
        : options
      cb(results)
    },
    async loadData() {
      const { selectedIndustry, category, rankType } = this
      if (!category) {
        this.$message('请选择职能模块')
        return
      }
      if (!selectedIndustry) {
        this.$message('请选择行业')
        return
      }
      this.loading = true
      try {
        const res = await window.app.service('project').simpleCompanies({
          行业: selectedIndustry,
        })
        if (!this.init) this.init = true
        this.companies = res.map(c => {
          const merge = []
          if (c.categoryMoneyTable && c.categoryMoneyTable[category]) {
            const { content, table } = c.categoryMoneyTable[category]
            table.map(item => {
              if (!item[rankType]) return
              merge.splice(0, 0, item)
            })
            c = Object.assign(c, content)
          }
          c.merge = merge
          return c
        })
        if (res.length > 0) {
          this.loadSalary()
        }
      } catch (error) {
        this.$message.error(error.message)
      }
      this.loading = false
    },
    async loadSalary(data) {
      const { rankType, category } = this
      const companies = this.companies || data
      if (!companies || companies.length === 0) return
      const names = companies.map(v => v['简称'])
      const companyNames = names.filter(Boolean)
      if (companyNames.length === 0) return
      this.pedding = true
      try {
        const res = await window.app
          .service('project')
          .companySalaryStatistics({
            companyNames,
            rankType,
            category,
          })

        // TODO:并行拆分，固薪: [总和, 人数, 最大, 最小],
        const format = {}
        const radishSalaries = res[0]
        radishSalaries.map(r => {
          if (!format[r['公司']]) {
            format[r['公司']] = { rank: {} }
          }
          if (!format[r['公司']].rank[r[rankType]]) {
            format[r['公司']].rank[r[rankType]] = {
              固薪: [0, 0, 0, 0],
              奖金: [0, 0, 0, 0],
              年薪: [0, 0, 0, 0],
            }
          }
          ;['固薪', '奖金', '年薪'].map(field => {
            if (!r[field]) return
            const floatValue = parseFloat(r[field])
            format[r['公司']].rank[r[rankType]][field][0] += floatValue
            format[r['公司']].rank[r[rankType]][field][1] += 1
            if (
              !format[r['公司']].rank[r[rankType]][field][2] ||
              format[r['公司']].rank[r[rankType]][field][2] < floatValue
            ) {
              format[r['公司']].rank[r[rankType]][field][2] = floatValue
            }
            if (
              !format[r['公司']].rank[r[rankType]][field][3] ||
              format[r['公司']].rank[r[rankType]][field][3] > floatValue
            ) {
              format[r['公司']].rank[r[rankType]][field][3] = floatValue
            }
          })
        })
        const departmentSalaries = res[1]
        departmentSalaries.map(d => {
          if (!format[d['公司']]) {
            format[d['公司']] = { rank: {} }
          }
          const content = d.departmentMoneyTable && d.departmentMoneyTable.content ? d.departmentMoneyTable.content : {}
          const table = d.departmentMoneyTable && d.departmentMoneyTable.table ? d.departmentMoneyTable.table : []
          table.map(item => {
            if (!item[rankType]) return
            if (!format[d['公司']].rank[item[rankType]]) {
              format[d['公司']].rank[item[rankType]] = {
                指标: [0, 0, 0, 0],
                固薪: [0, 0, 0, 0],
                奖金: [0, 0, 0, 0],
                年薪: [0, 0, 0, 0],
              }
            }
            if (item['年限'])
              format[d['公司']].rank[item[rankType]]['年限'] = item['年限']
            ;['指标', '固薪', '奖金', '年薪'].map(field => {
              if (!item[field]) return
              const memberCount = d['人数'] || 1
              const floatValue = parseFloat(item[field])
              format[d['公司']].rank[item[rankType]][field][0] +=
                floatValue * memberCount
              format[d['公司']].rank[item[rankType]][field][1] += memberCount
              if (
                !format[d['公司']].rank[item[rankType]][field][2] ||
                format[d['公司']].rank[item[rankType]][field][2] < floatValue
              ) {
                format[d['公司']].rank[item[rankType]][field][2] = floatValue
              }
              if (
                !format[d['公司']].rank[item[rankType]][field][3] ||
                format[d['公司']].rank[item[rankType]][field][3] > floatValue
              ) {
                format[d['公司']].rank[item[rankType]][field][3] = floatValue
              }
            })
          })
          ;['奖金机制', '奖金发放时间', '递延机制', '考核指标', '备注'].map(
            field => {
              if (content[field] && content[field].length > 0) {
                if (!format[d['公司']][field]) format[d['公司']][field] = []
                format[d['公司']][field].push({
                  department: d['名称'],
                  content: content[field],
                })
              }
            },
          )
        })
        this.format = Object.assign({}, format)
      } catch (error) {
        this.$message.error(error.message)
      }
      this.mergeCompanies()
      this.pedding = false
    },
    async mergeCompanies() {
      const { format, companies, rankType } = this
      if (companies.length === 0 || !format || Object.keys(format).length === 0)
        return
      companies.map(c => {
        if (!format[c['简称']]) return
        const existRank = {}
        const merge = c.merge
        merge.map(item => {
          if (!item[rankType]) return
          if (!existRank[item[rankType]]) existRank[item[rankType]] = true
          ;['固薪', '奖金', '年薪'].map(field => {
            if (
              item[field] ||
              !format[c['简称']].rank[item[rankType]] ||
              !format[c['简称']].rank[item[rankType]][field]
            )
              return
            item[field] =
              format[c['简称']].rank[item[rankType]][field][0] /
              (format[c['简称']].rank[item[rankType]][field][1] || 1)
          })
        })
        const computeRanks = Object.keys(format[c['简称']].rank)
        computeRanks.map(rank => {
          if (existRank[rank]) return
          const rankComputed = format[c['简称']].rank[rank]
          const fixed =
            rankComputed['固薪'][0] / (rankComputed['固薪'][1] === 0 || 1) || ''
          const bonus =
            rankComputed['奖金'][0] / (rankComputed['奖金'][1] === 0 || 1) || ''
          const annual =
            rankComputed['年薪'][0] / (rankComputed['年薪'][1] || 1) || ''
          c.merge.push({
            年限: rankComputed['年限'],
            [rankType]: rank,
            固薪: fixed,
            奖金: bonus,
            年薪: annual,
            fixedComputed: !!fixed,
            bonusComputed: !!bonus,
            annualComputed: !!annual,
            yearsComputed: !!rankComputed['年限'],
            rankComputed: true,
          })
        })
      })
    },
    addCol(company) {
      company.merge.push({
        年限: '',
        专业职级: '',
        管理职级: '',
        固薪: '',
        奖金: '',
        年薪: '',
      })
    },
    removeCol(company, i) {
      company.merge.splice(i, 1)
    },
    addText({ field, text, company }) {
      if (!company[field]) {
        company[field] = ''
      }
      company[field] += `；${text}`
    },
    async exportExel() {
      const {
        companies,
        checkList,
        selectedIndustry,
        category,
        rankType,
      } = this
      if (checkList.length === 0) {
        this.$message('请先选择需要导出的公司')
        return
      }
      const exportCompanies = []
      checkList.map((val, index) => {
        if (!val) return
        exportCompanies.push(companies[index])
      })
      if (exportCompanies.length === 0) return
      const workbook = []
      const opt = { '!merges': [] }
      exportCompanies.map((c, i) => {
        const merge = c.merge
        const mergeLength = merge.length
        const tableData = [[], [], [], [], [], []] // 年限，职级，指标，固薪，奖金，年薪
        merge.map((item, index) => {
          tableData[0].push(item['年限'] || '')
          tableData[1].push(item[rankType] || '')
          tableData[2].push(item['指标'] || '')
          tableData[3].push(item['固薪'] || '')
          tableData[4].push(item['奖金'] || '')
          tableData[5].push(item['年薪'] || '')
        })
        for (
          let index = i * 11;
          i * 11 <= index && index < i * 11 + 11;
          index += 1
        ) {
          if (!workbook[index]) workbook[index] = []
          switch (index % 11) {
            case 0:
              workbook[index][0] = i + 1
              workbook[index][1] = c['简称']
              workbook[index].push(...tableData[0])
              break
            case 6:
              workbook[index][3] = c['奖金机制']
              break
            case 7:
              workbook[index][3] = c['奖金发放时间']
              break
            case 8:
              workbook[index][3] = c['递延机制']
              break
            case 9:
              workbook[index][3] = c['考核指标']
              break
            case 10:
              workbook[index][3] = c['备注']
              break
            default:
              workbook[index] = [null, null, null].concat(tableData[index % 11])
              break
          }
          workbook[index][2] = staticSheet[index % 11]
        }

        // 头两列纵向合并，其余横向合并
        opt['!merges'].push(
          { s: { c: 0, r: 0 + i * 11 }, e: { c: 0, r: 10 + i * 11 } }, // 序号
          { s: { c: 1, r: 0 + i * 11 }, e: { c: 1, r: 10 + i * 11 } }, // 公司
          {
            s: { c: 3, r: 6 + i * 11 },
            e: { c: 3 + mergeLength, r: 6 + i * 11 },
          }, // 奖金机制
          {
            s: { c: 3, r: 7 + i * 11 },
            e: { c: 3 + mergeLength, r: 7 + i * 11 },
          }, // 奖金发放时间
          {
            s: { c: 3, r: 8 + i * 11 },
            e: { c: 3 + mergeLength, r: 8 + i * 11 },
          }, // 递延机制
          {
            s: { c: 3, r: 9 + i * 11 },
            e: { c: 3 + mergeLength, r: 9 + i * 11 },
          }, // 考核指标
          {
            s: { c: 3, r: 10 + i * 11 },
            e: { c: 3 + mergeLength, r: 10 + i * 11 },
          }, // 备注
        )
      })
      try {
        const url = await window.app.service('file').exportExcel({
          name: `${selectedIndustry}-${category}`,
          workbook,
          opt,
        })
        this.download({url})
      } catch (error) {
        console.error(error)
      }
    },
    async updateCompanySalary(company) {
      const merge = company.merge
      if (!merge || merge.length === 0) return
      const table = merge.map(item => ({
        专业职级: item['专业职级'],
        固薪: `${item['固薪']}`,
        奖金: `${item['奖金']}`,
        年薪: `${item['年薪']}`,
        年限: `${item['年限']}`,
        指标: `${item['指标']}`,
        管理职级: item['管理职级'],
      }))
      const category = this.category
      try {
        company.pedding = true
        await window.app.service('company').updateCategoryMoney({
          公司: company['简称'],
          data: {
            [category]: {
              content: {
                备注: company['备注'] || '',
                奖金发放时间: company['奖金发放时间'] || '',
                奖金机制: company['奖金机制'] || '',
                考核指标: company['考核指标'] || '',
                递延机制: company['递延机制'] || '',
              },
              table,
            },
          },
        })
        this.$message({
          type: 'success',
          message: '操作成功',
        })
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    async onTextareaResize(e) {
      if (e.target.style.height === `${e.target.scrollHeight}px`) return
      e.target.style.height = `${e.target.scrollHeight}px`
    },
    handleSort(company) {
      this.dialogVisible = true
      this.sortTarget = company
    },
    onCheck(index) {
      const checkList = this.checkList.slice()
      checkList[index] = !checkList[index]
      this.checkList = checkList
    },
  },
}
</script>

<style>
.page_container_content_nav {
  padding: 20px;
}
.page_container_content_tip {
  font-size: 18px;
  font-weight: bold;
  color: #aaa;
}
.salary_table_cell {
  position: relative;
  width: 40px;
  text-align: center;
  line-height: 24px;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.salary_table_cell_actived {
  border-right: 1px solid rgba(64, 158, 255, 1);
}
.salary_table_cell_full {
  min-width: 200px;
  max-width: 300px;
  padding: 4px 0;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.table_cell_border_r {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.table_cell_border_l {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
}
.table_cell_border_b {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.table_cell_border_t {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
.table_action_btn {
  color: #409eff;
  font-size: 14px;
}
.salary_table_cell_input {
  text-align: center;
  border: none;
  width: 100%;
  height: 100%;
}
.salary_table_cell_textarea {
  resize: vertical;
  border: none;
  width: 100%;
  height: 100%;
}
.salary_table_cell_min {
  min-width: 200px;
}
</style>
